import React from 'react';
import {BarChartData} from '../views/charts/BarChart';
import {LineChartData} from '../views/charts/LineChart';
import {KPI} from '../kpi';
import {Channel} from './Channel';
import {ColorHelper} from 'csx';

export enum TooltipComparisonMode {
    Absolute = 'absolute',
    Percent = 'percent',
    Disabled = 'disabled',
}

export interface VisibleAttribute {
    kpiRequestInfo: KpiPackage;
    moneyFormatting?: boolean;
    useAbsValue?: boolean;
    color?: ColorHelper;
    opacity?: number;
}

export interface KpiPackage {
    channel: Channel;
    searchtermOrProductId: string;
    kpi: KPI;
    isRate?: boolean;
    isChannelDiagram: boolean;
    isCompareDiagram: boolean;
    testId?: string;
    variantId?: string;
}

export interface KpiDataPackage extends KpiPackage {
    value: number;
    relValue: number;
    additionalInformation?: {name?: string; [key: string]: any}; // used when you want to add additional information to an entry, to fetch it in event handling later on
}

export interface ChartProps {
    width: number;
    height: number;
    kpiPackageToString?: (kpiPackage: KpiPackage, payload: BarChartData | LineChartData) => string | React.ReactNode;
    visibleAttribute: VisibleAttribute[];
    tooltipComparisonModeIfOneElementIsSelected?: TooltipComparisonMode;
    animation?: boolean;
}

export interface BaseChartData {
    data: KpiDataPackage[];
}



// WEBPACK FOOTER //
// ./src/types/Chart.ts